import type { Entity } from "../index"
import type { HasEntityWaterElevation } from "./HasEntityWaterElevation.type"

export default function isEntityHasWaterElevation(
  entity: Entity
): entity is Entity & HasEntityWaterElevation {
  return 'water_e' in entity
}
